// this is an autogenerated file from App/Account/Content/Settings/Content/Leads/Content/Content/Questions/Content/Editor/Content/EditArea/QuestionChooser/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_Leads_Content_Content_Questions_Content_Editor_Content_EditArea_QuestionChooser_Content($id: uuid!) {
  leads_question_templates {
    id
    text: name
    name
    prompt
    subprompt
  }
  medical_histories_questions(where: { organization_id: { _eq: $id } }) {
    id
    text: prompt
  }
}

`